export class createapp {
    
    appName:string;
    callBackUrl:string;
    constructor(){}
  
}
export interface createappResponse {
    status:string;
    appID:string;
    appName:string;
    clientSecret:string;
    callBackUrl:string;
    clientId :string;
    errorCode:string;
    errorMessage:string
    
    }
    